<div class="upload-summary">
  <div>
    <ui-upload-file-summary
      [summary]="summary"
      (downloadErrorFileEvent)="onDownloadErrorFile()"
    ></ui-upload-file-summary>
  </div>
  <div class="upload-summary__close">
    <img (click)="dimissModal()" src="assets/icon/common/cross.svg" />
  </div>
</div>
